import { styled } from '@mui/system';
import { Typography } from '@mui/material';

interface RowProps {
  bold?: boolean;
  firstRanked?: boolean;
  bottomTextInfo?: boolean;
}
const Row = styled('div')<RowProps>(
  ({ bold, firstRanked, bottomTextInfo }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '0 24px',
    minHeight: 48,
    borderTop: '1px solid #eaeaea',
    backgroundColor: firstRanked ? '#A5A6F633' : 'white',
    color: firstRanked ? '#5d5fef' : 'black',
    fontWeight: bold ? '600' : 'none',
    '&:last-child': {
      borderBottomLeftRadius: bottomTextInfo ? 'none' : '10px',
      borderBottomRightRadius: bottomTextInfo ? 'none' : '10px',
    },
  }),
);

interface PriceTextProps {
  bold?: boolean;
  discountColor?: boolean;
  firstRanked?: boolean;
}
const PriceText = styled('div')<PriceTextProps>(
  ({ bold, discountColor, firstRanked }) => ({
    fontWeight: bold ? '600' : '',
    color: discountColor || firstRanked ? '#5D5FEF' : 'black',
  }),
);

const ProviderNameDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  fontSize: '16px',
});

const Column = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  fontSize: '16px',
});

const SalePriceText = styled(Typography)({
  fontSize: '12px',
  fontWeight: '400',
  textDecoration: 'line-through',
});

const BottomContainer = styled('div')({
  padding: '12px 24px',
  borderTop: '1px solid #eaeaea',
});

const BottomTextNoInfo = styled(Typography)({
  textAlign: 'left',
  fontSize: '13px',
  color: '#979797',
});

const InfoText = styled(Typography)({
  fontSize: '14px',
  color: '#757475',
  fontWeight: '400',
  lineHeight: '21px',
});

export {
  Row,
  PriceText,
  ProviderNameDiv,
  Column,
  SalePriceText,
  BottomContainer,
  BottomTextNoInfo,
  InfoText,
};
